import {
  ApplicationConfig,
  LOCALE_ID,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CONCERN_BACKDROP_STYLE, withConcernTheme } from 'ngx-concern';
import { routes } from './app-routing.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    importProvidersFrom(BrowserModule, LazyLoadImageModule),
    { provide: LOCALE_ID, useValue: 'de' },
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'disabled' }),
      withComponentInputBinding()
    ),
    withConcernTheme('default', {
      provide: CONCERN_BACKDROP_STYLE,
      useValue: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
      },
    }),
  ],
};
